var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "aside",
    {
      staticClass: "filter product-filter",
      class: _vm.showfilters ? "open" : null,
      attrs: { id: "filter" }
    },
    [
      _c("div", { staticClass: "filter-header" }, [
        _c("h2", [_vm._v("Filter")]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "js-filter-clear filter-clear hide-mobile",
            attrs: { href: "javascript:void(0)" },
            on: {
              click: function($event) {
                return _vm.clearFilters()
              }
            }
          },
          [_vm._v("clear all filters")]
        ),
        _vm._v(" "),
        _c("i", {
          staticClass: "icon icon-close filter-close hide-desktop",
          on: { click: _vm.updateShowFilters }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "filters", attrs: { id: "filters" } }, [
        _c("div", { staticClass: "filter-section categories" }, [
          _c("h3", [_vm._v("Category")]),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "category-list" },
            _vm._l(_vm.categoryfilters, function(category) {
              return _c("li", { staticClass: "category" }, [
                _c(
                  "div",
                  {
                    staticClass: "category-header",
                    class: category.isOpen ? "open" : null,
                    attrs: { tabindex: "0" },
                    on: {
                      click: function($event) {
                        return _vm.toggleChildrenMenu(category)
                      },
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.toggleChildrenMenu(category)
                      }
                    }
                  },
                  [
                    category.hasActiveFilters
                      ? _c("span", { staticClass: "active-indicator" })
                      : _vm._e(),
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(category.CategoryName) +
                        "\n\t\t\t\t\t"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "child-categories",
                    class: category.isOpen ? "open" : null
                  },
                  [
                    _c("div", { staticClass: "child-menu-top" }, [
                      _c(
                        "div",
                        {
                          staticClass: "child-categories-header",
                          on: {
                            click: function($event) {
                              return _vm.toggleChildrenMenu(category)
                            }
                          }
                        },
                        [
                          _c("span", {
                            staticClass: "icon icon-angle-left hide-desktop"
                          }),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t" +
                              _vm._s(category.CategoryName) +
                              "\n\t\t\t\t\t\t\t"
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "form-group form checkbox-input select-all"
                        },
                        [
                          _c("input", {
                            attrs: { id: "child-select-all", type: "checkbox" },
                            domProps: { checked: category.isSelectAll },
                            on: {
                              change: function($event) {
                                return _vm.selectUnselectChildren(category)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "child-select-all" } }, [
                            _vm._v("Select All")
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      {
                        staticClass:
                          "filters-categories child-categories-list checkbox-grid three-column",
                        class: category.isOpen ? "open" : null
                      },
                      _vm._l(category.ChildCategories, function(child) {
                        return _c("li", { staticClass: "category" }, [
                          _c(
                            "div",
                            { staticClass: "form-group form checkbox-input" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.filters.categories,
                                    expression: "filters.categories"
                                  }
                                ],
                                attrs: {
                                  id: "filter-" + child.CategoryStr,
                                  type: "checkbox"
                                },
                                domProps: {
                                  value: child.CategoryStr,
                                  checked: Array.isArray(_vm.filters.categories)
                                    ? _vm._i(
                                        _vm.filters.categories,
                                        child.CategoryStr
                                      ) > -1
                                    : _vm.filters.categories
                                },
                                on: {
                                  change: [
                                    function($event) {
                                      var $$a = _vm.filters.categories,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = child.CategoryStr,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.filters,
                                              "categories",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.filters,
                                              "categories",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(_vm.filters, "categories", $$c)
                                      }
                                    },
                                    function($event) {
                                      return _vm.updateFilterList(
                                        category,
                                        child
                                      )
                                    }
                                  ]
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  attrs: { for: "filter-" + child.CategoryStr }
                                },
                                [_vm._v(_vm._s(child.CategoryName))]
                              )
                            ]
                          )
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-apply hide-mobile" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn",
                          on: {
                            click: function($event) {
                              return _vm.applyFilters()
                            }
                          }
                        },
                        [_vm._v("Apply Filters")]
                      )
                    ])
                  ]
                )
              ])
            }),
            0
          )
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "js-filter-clear filter-clear hide-desktop",
            attrs: { href: "javascript:void(0)" },
            on: {
              click: function($event) {
                return _vm.clearFilters()
              }
            }
          },
          [_vm._v("clear all filters")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "filter-section supplier-types" }, [
          _c("h3", [_vm._v("Supplier Type")]),
          _vm._v(" "),
          _c("ul", { staticClass: "filters-categories input-group" }, [
            _c("li", { staticClass: "category" }, [
              _c("div", { staticClass: "form-group form checkbox-input" }, [
                _c("input", {
                  attrs: {
                    id: "filter-my-supplier",
                    type: "checkbox",
                    value: "filters.isMySupplier"
                  },
                  domProps: { checked: _vm.filters.isMySupplier },
                  on: {
                    change: function($event) {
                      _vm.filters.isMySupplier = !_vm.filters.isMySupplier
                    }
                  }
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "filter-my-supplier" } }, [
                  _vm._v("MySupplier")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "category" }, [
              _c("div", { staticClass: "form-group form checkbox-input" }, [
                _c("input", {
                  attrs: {
                    id: "filter-cap",
                    type: "checkbox",
                    value: "filters.isCAP"
                  },
                  domProps: { checked: _vm.filters.isCAP },
                  on: {
                    change: function($event) {
                      _vm.filters.isCAP = !_vm.filters.isCAP
                    }
                  }
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "filter-cap" } }, [_vm._v("CAP")])
              ])
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "category" }, [
              _c("div", { staticClass: "form-group form checkbox-input" }, [
                _c("input", {
                  attrs: { id: "filter-cap", type: "checkbox" },
                  domProps: { checked: _vm.filters.isCOOP },
                  on: {
                    change: function($event) {
                      _vm.filters.isCOOP = !_vm.filters.isCOOP
                    }
                  }
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "filter-cap" } }, [_vm._v("Co-op")])
              ])
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "category" }, [
              _c("div", { staticClass: "form-group form checkbox-input" }, [
                _c("input", {
                  attrs: { id: "filter-cap", type: "checkbox" },
                  domProps: { checked: _vm.filters.isNAPRating },
                  on: {
                    change: function($event) {
                      _vm.filters.isNAPRating = !_vm.filters.isNAPRating
                    }
                  }
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "filter-cap" } }, [
                  _vm._v("NAP Star Rating")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "category" }, [
              _c("div", { staticClass: "form-group form checkbox-input" }, [
                _c("input", {
                  attrs: { id: "filter-cap", type: "checkbox" },
                  domProps: { checked: _vm.filters.isB2B },
                  on: {
                    change: function($event) {
                      _vm.filters.isB2B = !_vm.filters.isB2B
                    }
                  }
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "filter-cap" } }, [_vm._v("B2B")])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "filter-actions",
          class: _vm.filterActionsStuck ? "static" : ""
        },
        [
          _c(
            "button",
            {
              staticClass: "btn",
              on: {
                click: function($event) {
                  return _vm.applyFilters()
                }
              }
            },
            [_vm._v("Apply Filters")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "js-filter-clear hide-mobile",
              attrs: { href: "javascript:void(0)" },
              on: {
                click: function($event) {
                  return _vm.clearFilters()
                }
              }
            },
            [_vm._v("Clear Filters")]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a0904ab", { render: render, staticRenderFns: staticRenderFns })
  }
}